<template>
    <div class='index'>
		
       <Bar />
       <router-view></router-view>
        <Sim />
        <Place />
    </div>
</template>
<script>
import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'
import Sim from '@/components/sim/sim'

export default {
    components:{
        Bar,Place,Sim
    }, mounted() {

		this.sandMate();

		},methods: {
			
	sandMate(){
		if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
		  this.$router.push({ path: "/login" });	
		}
	}
		
			 
			 }
		    
		
}

</script>